export default {
	state: {
		selectedBrandCategory: null,
		selectedStore: null,
	},
	getter: {},
	mutations: {
		setSelectedBrandCategory(state, brandCategory) {
			state.selectedBrandCategory = brandCategory;
		},
		setSelectedStore(state, store) {
			state.selectedStore = store;
		},
	},
	actions: {},
};
